export class ObjectHelpers {
    public static copy(obj: any) {
        return JSON.parse(JSON.stringify(obj));
    }

    public static setProperties(source: any, destination: any, onlyPropertyWithValue?: boolean) {
        for (const prop in source) {
            if (typeof source[prop] !== 'function') {
                if (onlyPropertyWithValue) {
                    if (source[prop] || source[prop] === 0 || source[prop] === false || source[prop] === null) {
                        destination[prop] = source[prop];
                    }
                } else {
                    destination[prop] = source[prop];
                }
            }
        }
    }

    public static setPropertiesAndFunctions(source: any, destination: any, onlyPropertyWithValue?: boolean) {
        for (const prop in source) {
            if (onlyPropertyWithValue) {
                if (source[prop] || source[prop] === 0 || source[prop] === false || source[prop] === null) {
                    destination[prop] = source[prop];
                }
            } else {
                destination[prop] = source[prop];
            }
        }
    }
    
    static toCamel(data: any): any {
        let result: any;
        let origKey: any;
        let newKey: any;
        let value: any;
        if (data instanceof Array) {
            result = [];
            for (origKey in data) {
                if (data[origKey]) {
                    value = data[origKey];
                    if (typeof value === 'object') {
                        value = this.toCamel(value);
                    } else if (value instanceof Array) {
                        value = this.toCamel(value);
                    }

                    if (typeof value !== 'function') {
                        result.push(value);
                    }
                }
            }
        } else {
            result = {};
            for (origKey in data) {
                if (data.hasOwnProperty(origKey)) {
                    newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                    value = data[origKey];
                    if (value !== null && value !== undefined && value.constructor === Object) {
                        value = this.toCamel(value);
                    } else if (value !== null && value !== undefined && value.constructor === Array) {
                        value = this.toCamel(value);
                    }
                    result[newKey] = value;
                }
            }
        }

        return result;
    }

    static toCapitalize(data: any):any[] | {} {
        let result: any, newKey: string, value: any;
        if (data instanceof Array) {
            result = [];
            for (const origKey of Object.keys(data)) {
                value = data[parseInt(origKey, 10)];
                if (typeof value === 'object') {
                    value = this.toCapitalize(value);
                } else if (value instanceof Array) {
                    value = this.toCapitalize(value);
                }
                result.push(value);
            }
        } else {
            result = {}
            for (const origKey of Object.keys(data)) {
                if (data.hasOwnProperty(origKey)) {
                    newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString();
                    value = data[origKey];
                    if (value !== null && value !== undefined && value.constructor === Object) {
                        value = this.toCapitalize(value);
                    } else if (value !== null && value !== undefined && value.constructor === Array) {
                        value = this.toCapitalize(value);
                    }
                    result[newKey] = value;
                }
            }
        }
        return result;
    }
}